import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as VenngageLogoIcon } from 'assets/icons/venngage_logo.svg';
import { memo, useEffect, useState } from 'react';

import { DELAY_TO_LIVE_READING } from '../Chat.config';
import { BotMessageProps } from '../Chat.types';

/**
 * Render the basic bot message in the ChatPanel
 * If it is the first index. margin is auto to push the message to the bottom
 *
 * @param data.messages[0] The text to be displayed
 */
export const BotMessage = memo(({ data, index }: BotMessageProps) => {
  const isFistMessage = index === 0;

  const ChatBotMessageTestId = 'chat-bot-message';

  /**
   * [INFO–157] – Content not read by screen reader
   * aria-live would read the updated content of a component,
   * Adding a delay here so the screen reader would be able to complete reading other content and then
   * read this one. If not adding a delay, the reader would not read this because it is busy on reading others
   */
  const displayMessage = data.messages[0];
  const [message, setMessage] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(displayMessage);
    }, DELAY_TO_LIVE_READING);

    return () => clearTimeout(timer);
  }, [displayMessage]);

  return (
    <Flex mt={`${isFistMessage ? 'auto' : ''}`} gap='4' data-testid={ChatBotMessageTestId} aria-live='assertive'>
      <Flex alignItems='flex-end'>
        <VenngageLogoIcon width='24px' height='24px' color='var(--vg-colors-brand-500)' />
      </Flex>
      <Box p='2' borderRadius='lg' bg='violet.50' flexGrow='1'>
        <Text>{message}</Text>
      </Box>
    </Flex>
  );
});

BotMessage.displayName = 'BotMessage';
